export const SPORTS_DETAIL_LOAD = 'sports_detail/on_load';
export const sportsDetailLoad = (id, platformType) => ({
  type: SPORTS_DETAIL_LOAD,
  id: id,
  platformType: platformType
});

export const SPORTS_DETAIL_LOAD_SUCCESS = 'sports_detail/on_load_success';
export const sportsDetailLoadSuccess = (data, recorded, plan) => ({
  type: SPORTS_DETAIL_LOAD_SUCCESS,
  payload: data,
  recorded: recorded,
  plan: plan
});

export const PACKAGE_CHANNEL_LOAD = 'sports_detail/package_channel_load';
export const packageChannelLoad = (data) => ({
  type: PACKAGE_CHANNEL_LOAD,
  payload: data
});

export const PACKAGE_CHANNEL_LOAD_SUCCESS = 'sports_detail/package_channel_load_success';
export const packageChannelLoadSuccess = (data) => ({
  type: PACKAGE_CHANNEL_LOAD_SUCCESS,
  payload: data
});
